/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type GeneratedAssignmentAttemptItemResult = 'PENDING' | 'CORRECT' | 'INCORRECT';

export const GeneratedAssignmentAttemptItemResult = {
  Pending: 'PENDING' as GeneratedAssignmentAttemptItemResult,

  Correct: 'CORRECT' as GeneratedAssignmentAttemptItemResult,

  Incorrect: 'INCORRECT' as GeneratedAssignmentAttemptItemResult,
};
